/**
 * Amplitude event names, kept in one place so the taxonomy agreed with the data
 * team stays stable — renaming an event here breaks every dashboard built on it.
 *
 * Events marked "without user" fire before the user is identified, so they carry
 * only the global properties AmplitudeService attaches to every event.
 */
export class AmplitudeEvent {
  // Auth funnel (without user)
  static LOGIN_PAGE_VIEWED = 'Login Page Viewed';
  static OTP_SCREEN_PAGE_VIEWED = 'OTP Screen Viewed';
  static OTP_SUBMITTED = 'OTP Submitted';
  static USER_LOGGED_IN = 'User Logged In';
  static USER_LOGGED_OUT = 'User Logged Out';

  // Shipment funnel
  static CREATE_SHIPMENT_PAGE_VIEWED = 'Create Shipment Page Viewed';
  static SHIPMENT_CREATED = 'Shipment Created';
  static SHIPMENT_DETAILS_VIEWED = 'Shipment Details Viewed';
  static ACCEPT_BID_CLICKED = 'Accept Bid Clicked';
  /** Not in the original sheet: the conversion that follows the click above. */
  static BID_ACCEPTED = 'Bid Accepted';
}

/** `method` on `user_logged_in`: how the session was authenticated. */
export enum AmplitudeLoginMethod {
  Otp = 'otp',
  Email = 'email',
}

/** `source` on `otp_screen_page_viewed`: the flow that led to the OTP screen. */
export enum AmplitudeOtpSource {
  Login = 'login',
  Registration = 'registration',
}

/**
 * `template` on the shipment events: `ShipmentCreationTemplateTypes` → the
 * lowercase names the data team reports on (`bidding | basic | custom | cement`).
 * `ORDER_ORIENTED` is the order-oriented template, reported as `custom`.
 */
export const AMPLITUDE_TEMPLATE_NAMES: Record<string, string> = {
  BASIC: 'basic',
  BIDDING: 'bidding',
  CEMENT: 'cement',
  ORDER_ORIENTED: 'custom',
};

/** `error_type` on a failed `otp_submitted`. */
export enum AmplitudeOtpErrorType {
  InvalidOtp = 'invalid_otp',
  ExpiredOtp = 'expired_otp',
  TooManyAttempts = 'too_many_attempts',
  Unknown = 'unknown',
}
